<template>
    <v-container fluid>
        <v-row no-gutters class="d-block">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                    <v-card-title>
                        <v-row>

                            <v-col cols="6" sm="3" md="3" lg="3" xl="3">
                                <v-btn color="success" v-if="permisos[2]" small outlined @click="personaNuevo()">
                                    <v-icon>add</v-icon>
                                    Nuevo
                                </v-btn>
                            </v-col>

                            <v-col cols="6" sm="3" md="3" lg="3" xl="3">

                                <v-btn color="info" small outlined @click="personasGet()">
                                    <v-icon>refresh</v-icon>
                                    Refrescar
                                </v-btn>

                            </v-col>
                            <v-col cols="12" class="pt-0">
                                <buscador-campos
                                    ref="buscador"
                                    :campos="camposBusqueda"
                                    sugerir-personas
                                    :tipo-persona="2"
                                    :cargando="loading"
                                    @buscar="buscar"
                                    @limpiar="buscar({texto: '', campo: 'todos', persona: null})"
                                />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            dense
                            class="elevation-3"
                            :headers="tableHeaders"
                            :items="personas"
                            :loading="loading"
                            item-key="persona_id"
                            fixed-header
                            height="65vh"
                            :hide-default-footer="true"
                            disable-pagination
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left text-no-wrap" v-html="resaltar(item.numero_identidad, 'identidad')"></td>
                                    <td class="text-left" style="min-width: 210px">
                                        <div class="d-flex align-center">
                                            <v-avatar size="34" class="mr-2 flex-shrink-0" :color="item.foto_url ? 'transparent' : 'grey lighten-2'"
                                                      :title="item.foto_url ? '' : 'Sin fotografía en su perfil'">
                                                <img v-if="item.foto_url" :src="item.foto_url" :alt="'Foto de ' + item.nombre" loading="lazy">
                                                <v-icon v-else small color="grey darken-1">no_photography</v-icon>
                                            </v-avatar>
                                            <span v-html="resaltar(item.nombre + ' ' + item.apellido, 'nombre')"></span>
                                        </div>
                                    </td>
                                    <td class="text-left">{{ item.usuario || '—' }}</td>
                                    <td class="text-left">{{ item.correo }}</td>
                                    <td class="text-left">{{ item.departamento_trabajo || '—' }}</td>
                                    <td class="text-left" style="min-width: 120px">
                                        <span v-if="item.ultimo_acceso">{{ item.ultimo_acceso | fechaESPHora }}</span>
                                        <span v-else class="grey--text">Nunca</span>
                                    </td>
                                    <td class="text-center">
                                        <v-chip x-small label text-color="white" :color="estado(item).color" :title="estado(item).ayuda">
                                            {{ estado(item).texto }}
                                        </v-chip>
                                    </td>
                                    <td class="text-center text-no-wrap">
                                        <v-btn color="info" small outlined @click="personasEdit(item)" title="Editar" v-if="permisos[3]">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn color="error" small outlined class="ml-1" @click="pedirEliminar(item)" title="Eliminar perfil" v-if="permisos[4]">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                <v-alert dense type="warning" outlined class="text-center mt-3">
                                    No existen registros.
                                </v-alert>
                            </template>
                        </v-data-table>
                        <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina"
                                    v-if="pagination.total"/>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Confirmar eliminación de un perfil -->
        <v-dialog v-model="dialogoEliminar" max-width="480">
            <v-card v-if="personaEliminar">
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    <v-icon left color="error">warning</v-icon> ¿Eliminar este perfil?
                </v-card-title>
                <v-card-text>
                    <p class="mb-2">
                        <b>{{ personaEliminar.nombre }} {{ personaEliminar.apellido }}</b>
                        <span v-if="personaEliminar.usuario"> (usuario <b>{{ personaEliminar.usuario }}</b>)</span>
                    </p>
                    <p class="mb-3">
                        Se eliminarán su perfil y sus credenciales, y se cerrarán sus sesiones abiertas.
                        Ya no podrá ingresar al sistema. El registro de accesos y los memorandos se conservan.
                    </p>
                    <v-text-field
                        v-model="confirmacionEliminar" outlined dense hide-details
                        :label="`Escriba ELIMINAR para confirmar`"
                        @keyup.enter="eliminar"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text small @click="dialogoEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" small :loading="eliminando"
                           :disabled="confirmacionEliminar.trim().toUpperCase() !== 'ELIMINAR'" @click="eliminar">
                        <v-icon small left>delete</v-icon> Eliminar perfil
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import Auth from "@/services/auth";
const Pagination = () => import("@/pages/Components/Pagination.vue");
import BuscadorCampos, {CAMPOS_PERSONAS} from "@/components/Buscador/BuscadorCampos.vue";

export default {
    name: 'ParticipantesAdministradoresLista',
    components: {Pagination, BuscadorCampos},
    data() {
        return {
            permisos: [],
            dialogoEliminar: false,
            personaEliminar: null,
            confirmacionEliminar: "",
            eliminando: false,
            personas: [],
            pagination: {},
            pageActual: 1,
            rowsPage: this.$store.state.arrayRowsPages[0],
            search: "",
            campo: "todos",
            secuenciaConsulta: 0,
            camposBusqueda: CAMPOS_PERSONAS,
            loading: false,
            filtros: {
                cat_tipo_persona_id: 2
            },
            tableHeaders: [
                {
                    text: 'N.° Identidad',
                    value: 'numero_identidad',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Nombre',
                    value: 'nombre',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Usuario',
                    value: 'usuario',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Correo',
                    value: 'correo',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Departamento',
                    value: 'departamento_trabajo',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Último acceso',
                    value: 'ultimo_acceso',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Estado',
                    value: 'activo',
                    align: 'center',
                    sortable: true
                },
                {
                    text: 'Acciones',
                    align: 'center',
                    sortable: false
                },
            ],
        }
    },

    methods: {
        personaNuevo() {
            this.$router.push({name: 'ParticipantesAdministradoresNuevo'});
        },
        buscar(criterio) {
            this.search = criterio.texto;
            this.campo = criterio.campo;
            // Participante elegido en las sugerencias: se busca por su identidad exacta.
            if (criterio.participante) {
                this.search = criterio.participante.numero_identidad;
                this.campo = "identidad";
            }
            this.pageActual = 1;
            this.personasGet();
        },
        resaltar(valor, columna) {
            const buscador = this.$refs.buscador;
            return buscador ? buscador.resaltar(valor, columna) : (valor || "");
        },
        personasBuscar() {
            this.pageActual = 1;
            this.personasGet();
        },
        personasGet() {
            this.loading = true;
            const secuencia = ++this.secuenciaConsulta;
            let params = {filtros: this.filtros, busqueda: this.search, campo: this.campo, page: this.pageActual, rowsPage: this.rowsPage};
            window.axios.get('/personas', {params}).then(response => {
                if (secuencia !== this.secuenciaConsulta) return;
                if (response.data.success) {
                    let data = response.data.data;
                    this.personas = data.personas.data;
                    this.pagination = data.pagination;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        estado(persona) {
            if (persona.activo) return {texto: "Activo", color: "success", ayuda: "Puede ingresar"};
            if (persona.desactivado_motivo === "inactividad") {
                return {texto: "Inactividad", color: "warning", ayuda: "Desactivado automáticamente por no ingresar. Reactívelo desde Editar."};
            }
            return {texto: "Desactivado", color: "grey", ayuda: "Desactivado por un administrador"};
        },
        pedirEliminar(persona) {
            this.personaEliminar = persona;
            this.confirmacionEliminar = "";
            this.dialogoEliminar = true;
        },
        eliminar() {
            if (this.confirmacionEliminar.trim().toUpperCase() !== "ELIMINAR" || this.eliminando) return;

            this.eliminando = true;

            window.axios.post('/personas/delete', {persona_id: this.personaEliminar.persona_id}).then(response => {
                if (response.data.success) {
                    this.$toast.success("Perfil eliminado.");
                    this.dialogoEliminar = false;
                    this.personasGet();
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    const cuerpo = error.response && error.response.data;
                    this.$toast.error((cuerpo && cuerpo.message) || "No se pudo eliminar el perfil.");
                })
                .finally(() => {
                    this.eliminando = false;
                });
        },
        personasEdit(persona) {
            if (typeof persona == "object") {
                let token = window.btoa(persona.persona_id);
                this.$router.push({name: 'ParticipantesAdministradoresEditar', query: {token}});
            } else {
                this.$toast.error("Parametro no valido.");
            }
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.personasGet();
        },
    },
    created() {
        Auth.checkPermisos(this.$route.path).then((res) => {
            this.permisos = res;
            this.personasGet();
        });
    }
}
</script>

<style>

</style>
